"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var interpolate_1 = require("./utils/interpolate");
var axios_1 = require("axios");
var config = require('./assets/config.json');
var mapResponseToBeSameAsStores = function (data) {
    // TODO this mapping should be removed, after stores will response with same charge object
    if (!data.charge || !data.charge.state) {
        return data;
    }
    return {
        chargeId: data.charge.chargeId,
        failureDetails: data.charge.state.failureDetails && data.charge.state.failureDetails.failureCode,
        redirectUrl: data.charge.state.userRedirectUrl,
        transactionStatus: data.charge.state.transactionStatus && data.charge.state.transactionStatus.status
    };
};
/**
 * Class will contain pure API requests
 */
var ApiCalls = /** @class */ (function () {
    function ApiCalls() {
        this.charge = function (_a) {
            var request = _a.request, _b = _a.host, host = _b === void 0 ? '' : _b;
            var url = host + interpolate_1.default(config.orderChargesUrl, { orderId: request.orderId });
            return axios_1.default
                .post(url, request)
                .then(function (response) { return mapResponseToBeSameAsStores(response.data); });
        };
        this.fetchPaymentMethodSettings = function (_a, host) {
            var orderId = _a.orderId, appId = _a.appId, appInstanceId = _a.appInstanceId, paymentMethod = _a.paymentMethod, country = _a.country;
            if (host === void 0) { host = ''; }
            var paymentMethodUrlMask = orderId ? config.paymentMethodOrderApiUrl : config.paymentMethodAccountApiUrl;
            var url = interpolate_1.default(paymentMethodUrlMask, { orderId: orderId, appId: appId, appInstanceId: appInstanceId, paymentMethod: paymentMethod });
            return axios_1.default
                .get(host + url, { params: { country: country } })
                .then(function (response) { return response.data; });
        };
    }
    return ApiCalls;
}());
exports.default = new ApiCalls();
//# sourceMappingURL=apiCalls.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-sdk/dist/src/apiCalls.js
// module id = 394
// module chunks = 0 1